import { IController } from 'angular';
import * as _ from 'lodash';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class SafetyNetEligibleTransferCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  private activeStudentsByCohort;
  private studentIdsByEligibility;
  private studentFilter;
  private cohort;
  public activeStudentsByCohortFilter;
  public activeStudentIds;
  public activeStudentIdsFilter;
  public currentCohortFilter;
  public filterOptions;
  // studentIds by gradPlan -- calc and current:
  public inEligibleStudentIds: string[];
  public isSafetyNetEligibleIds: string[];
  public notVerifiedSafetyNetEligibleIds: string[];

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.filterOptions = { columnKeys: ['gradPlan', 'isSafetyNetEligible'] };
    this.cohort = this.WizardUtils.getCurrentCohortFilter();
    this.studentFilter = this.cohort ? { status: ['A', 'A-NDG'], cohort: this.cohort } : { status: ['A', 'A-NDG'] };
    this.currentCohortFilter = this.cohort && this.cohort.length > 1 ? null : _.last(this.cohort);
    this.activeStudentsByCohort = this.WizardUtils.getFilteredFlattenedStudents(this.studentFilter);
    this.studentIdsByEligibility = this.generateFilteredStudentIdBuckets();
    this.activeStudentIds = this.studentIdsByEligibility.activeStudentIds;
    // bullet one
    this.isSafetyNetEligibleIds = this.studentIdsByEligibility.isSafetyNetEligibleIds;
    // bullet two
    this.notVerifiedSafetyNetEligibleIds = this.studentIdsByEligibility.notVerifiedSafetyNetEligibleIds;
    // bullet three
    this.inEligibleStudentIds = this.studentIdsByEligibility.inEligibleStudentIds;
  }

  private generateFilteredStudentIdBuckets(): object {
    const activeStudentIds = [];
    const isSafetyNetEligibleIds = [];
    const notVerifiedSafetyNetEligibleIds = [];
    const inEligibleStudentIds = [];

    _.each(this.activeStudentsByCohort, (student: any) => {
      const { studentId } = student;
      activeStudentIds.push(studentId);
      if (student.isSafetyNetEligible) isSafetyNetEligibleIds.push(studentId);

      if (student.potentiallyEligibleForSafetyNet && !student.schoolVerifiedSafetyNetEligibility) {
        notVerifiedSafetyNetEligibleIds.push(studentId);
      }
      if (!student.isSafetyNetEligible && !student.potentiallyEligibleForSafetyNet) {
        inEligibleStudentIds.push(studentId);
      }
    });
    return { activeStudentIds, isSafetyNetEligibleIds, notVerifiedSafetyNetEligibleIds, inEligibleStudentIds };
  }
}
